//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['property'],
    data: function data() {
        return {
            notLegacy: false,
            loading: true,
            settingsDataLoading: false,
            propertyUtilityDataLoading: false,
            showOverlay: true,
            basicEdit: false,
            propSettings: {},
            settingsEdit: false,
            utilEdit: false,
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '$',
                suffix: '',
                precision: 2,
                masked: false
            },
            percent: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: '%',
                precision: 2,
                masked: false
            }
        };
    },
    mounted: function mounted() {
        this.refreshData();
    },

    methods: {
        refreshData: function refreshData() {
            var $el = this;
            if ($el.property) {

                $el.settingsDataLoading = true;
                $el.propertyUtilityDataLoading = true;

                axios.get('/prototype/properties/generalSettingsLegacy').then(function (response) {
                    if (response.data) {
                        $el.propSettings = response.data;
                    } else {
                        $el.notLegacy = true;
                    }

                    $el.settingsDataLoading = false;
                    $el.propertyUtilityDataLoading = false;
                    $el.loading = false;
                });
            }
        },
        savePropertyUtilityData: function savePropertyUtilityData() {
            var $el = this;
            this.utilEdit = false;
            this.propertyUtilityDataLoading = true;
            this.propSettings.legacy = true;
            axios.post('/prototype/properties/' + $el.property + "/generalSettings", { propSettings: this.propSettings }).then(function (response) {
                if (response.data) {
                    $el.propSettings = response.data;
                }
                $el.propertyUtilityDataLoading = false;
            });
        },
        saveSettingsData: function saveSettingsData() {
            var $el = this;
            this.settingsEdit = false;
            this.settingsDataLoading = true;
            this.propSettings.legacy = true;
            axios.post('/prototype/properties/' + $el.property + "/generalSettings", { propSettings: this.propSettings }).then(function (response) {
                if (response.data) {
                    $el.propSettings = response.data;
                }
                $el.settingsDataLoading = false;
            });
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/settings/LegacySettings.vue
// module id = 7uze
// module chunks = 0 1